import { Component, OnDestroy, OnInit } from '@angular/core';
import { Quote, QuoteState } from '@app/quoting/models/quote';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { DateConstants } from '@app/constants/date-constants';
import { combineLatest, of, Subscription } from 'rxjs';
import { configurationSelector, quoteConfigurationSelector, quoteSelector, utilityAccountsSelector } from '@app/state/app.selectors';
import moment from 'moment';
import { QuoteHelperService } from '../../services/quote-helper.service';
import { ProductConfiguration } from '../../../configuration/models/product-configuration';
import { QuotingAvailability } from '../../models/quoting-availability';
import { UtilityAccount } from '@app/shared/models/UtilityAccount';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-quote-status-message',
  templateUrl: './quote-status-message.component.html',
  styleUrls: ['./quote-status-message.component.scss']
})
export class QuoteStatusMessageComponent implements OnInit, OnDestroy {
  public quoteStateType = QuoteState;
  public dateFormat = DateConstants.LOCALE_FORMAT_SHORT();
  quote: Quote;
  configuration: ProductConfiguration;

  public quoteState: QuoteState;
  public fetching: boolean;
  selectQuote$: Subscription;
  date$: any;
  public utilityAccounts: UtilityAccount[];
  public newContractStartDates: string[];
  public quoteConfiguration: any;

  constructor(
    private store: Store<AppState>,
    public quoteHelperService: QuoteHelperService) { }

  ngOnDestroy(): void {
    this.selectQuote$?.unsubscribe();
  }

  ngOnInit(): void {
    this.selectQuote$ = this.store.select(quoteSelector).pipe(
      switchMap((s) => {
        this.quote = s.quote;
        this.setDate(this.quote?.quoteDate);
        return combineLatest([
          this.store.select(configurationSelector),
          this.store.select(utilityAccountsSelector),
          this.store.select(quoteConfigurationSelector)
        ]);
      })
    ).subscribe(([configuration, utilityAccounts, quoteConfiguration]) => {
      this.configuration = configuration.configuration;
      this.utilityAccounts = utilityAccounts;
      this.quoteConfiguration = quoteConfiguration;
      this.newContractStartDates = this.quoteHelperService.determineContractStartDates(this.quote, quoteConfiguration, utilityAccounts);
    });
  } 

  public setDate(quoteDate: Date): void {
    this.date$ = moment(quoteDate, 'YYYY.MM.DD H:mm:ss') < moment(new Date(), 'YYYY.MM.DD H:mm:ss') ? of(new Date()) : of(quoteDate);
  }

  public GetQuotingAvailability(): QuotingAvailability {
    return this.quoteHelperService.IsQuotationDisabled(this.configuration, this.newContractStartDates);
  }
}
